import { ChangeEvent, ElementType, ReactNode, useRef, useState } from 'react';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Button, ButtonProps, styled } from '@mui/material';

const ButtonStyled = styled(Button)<ButtonProps & { component?: ElementType; htmlFor?: string }>(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        textAlign: 'center',
    },
}));

type UploadButtonProps = {
    id: string;
    children: ReactNode;
    onUpload: (files: FileList) => void;
    acceptType?: string;
};

const UploadButton = ({
    id,
    onUpload,
    children,
    acceptType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
}: UploadButtonProps) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [showSelectFile, setShowSelectFile] = useState(false);

    const handleFileUpload = async (file: ChangeEvent, onChange: any) => {
        setShowSelectFile(false);
        const { files } = file.target as HTMLInputElement;

        if (files != null) {
            onUpload(files);
        } else {
        }
    };

    const clearInput = () => {
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };

    return (
        <ButtonStyled
            onClick={clearInput}
            size="small"
            component="label"
            variant="contained"
            htmlFor={id}
            endIcon={<FileUploadIcon />}
            sx={{ mt: 2, mb: 2 }}
        >
            {children}
            <input
                hidden
                type="file"
                ref={inputRef}
                onChange={(e) => handleFileUpload(e, handleFileUpload)}
                accept={acceptType}
                id={id}
            />
        </ButtonStyled>
    );
};

export default UploadButton;
